<p-tag [style]="{
    backgroundColor: this.status.bgcolor,
    color: this.status.textcolor
  }">{{ "STATUS." + status.name | translate}}</p-tag>